import { generateUUID } from '@thoughtspot/js-util';
import PDom from 'parallel-dom';
import React, { useEffect, useRef } from 'react';
import styles from '../../styles/chart.module.scss';
import { chartTypeToScriptUrlMap } from '../../utils/chart-type-url-map';
import { appendExtraDataToUrl } from '../../utils/extra-data';
if (window.crypto && !window.crypto.randomUUID) {
    window.crypto.randomUUID = generateUUID;
}
export const PDomComponent = ({ elementId, targetFrameUrl, chartType, disableOriginAgentCluster, onLoad, onError, chartIframeElRef, extraData }) => {
    const targetFrameUrlWithExtraData = appendExtraDataToUrl(targetFrameUrl, extraData);
    const hostContainerRef = useRef(null);
    const lastAppliedHeightRef = useRef(null);
    useEffect(() => {
        let resizeObserver;
        const stabilizeIframeViewportHeight = () => {
            const iframeEl = chartIframeElRef.current;
            const hostContainer = hostContainerRef.current;
            if (!iframeEl || !hostContainer) {
                return;
            }
            const nextHeight = Math.round(hostContainer.getBoundingClientRect().height);
            if (lastAppliedHeightRef.current !== null &&
                Math.abs(nextHeight - lastAppliedHeightRef.current) <= 1) {
                return;
            }
            lastAppliedHeightRef.current = nextHeight;
            const heightPx = `${nextHeight}px`;
            iframeEl.style.height = heightPx;
            iframeEl.setAttribute('scrolling', 'no');
        };
        const pDom = new PDom(`#${elementId}`, {
            scripts: [
                chartTypeToScriptUrlMap[chartType],
            ],
            domainUrl: targetFrameUrlWithExtraData,
            disableOriginAgentCluster,
        });
        chartIframeElRef.current = pDom.containerEl;
        pDom.render()
            .then(() => {
            stabilizeIframeViewportHeight();
            if (window.ResizeObserver && hostContainerRef.current) {
                resizeObserver = new ResizeObserver(() => {
                    stabilizeIframeViewportHeight();
                });
                resizeObserver.observe(hostContainerRef.current);
            }
            onLoad(`#${elementId}`);
        }, onError)
            .catch(onError);
        return () => {
            resizeObserver?.disconnect();
        };
    }, [chartType]);
    return (React.createElement("div", { className: styles.chartIframe, id: elementId, ref: hostContainerRef }));
};
//# sourceMappingURL=p-dom.component.js.map